export default "__VITE_ASSET__2fb33377__"